import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { OfferService } from './offer.service';
import { OfferStore } from './offer.store';
import { OfferState, Offer } from './offer.type';
import { RewardQuery } from '../reward/reward.query';

@Injectable({ providedIn: 'root' })
export class OfferQuery extends Query<OfferState> {
  isLoading$ = this.selectLoading();
  offers$ = this.select((state) => state.data);
  tailoredOffers$ = this.select((state) => state.data).pipe(
    map((offerCategories) => {
      if (!offerCategories) {
        // Still loading from initial state
        return;
      }
      const userPoints = this.rewardQuery.getValue().totalPointsBalance;
      const tailoredOffers = offerCategories.reduce((currentOffers, offerCategory) => {
        currentOffers.push(
          ...offerCategory.data.filter((offer) => offer.amount <= userPoints),
        );
        // Take 5; user clicks 'See all' button to see all their offers (and ones not tailored to them)
        return currentOffers
          .slice(0, 5)
          .sort((offer1, offer2) => (offer1.amount < offer2.amount ? 1 : -1));
      }, [] as Offer[]);
      return tailoredOffers;
    }),
  );
  // limitedOffers$ = this.select((state) =>
  //   state.data?.filter((o) => o?.offerType === 'limited_offers'),
  // );
  // oneBillRewardStoreOffers$ = this.select((state) =>
  //   state.data?.filter((o) => o?.offerType === 'qantas_reward_store'),
  // );
  // ourPartnerOffers$ = this.select((state) =>
  //   state.data?.filter((o) => o?.offerType === 'our_partners'),
  // );
  offerDetails$ = this.getOfferDetails();
  offerCategoryDetails$ = this.getOffersForOfferCategory();
  redeemedOffers$ = this.select('redeemedOffers');
  redeemedPromoCodes$ = this.select('redeemedPromoCodes');

  constructor(protected store: OfferStore, private offerService: OfferService, private rewardQuery: RewardQuery) {
    super(store);
  }

  private getOfferDetails() {
    return this.getCurrOffer();
  }

  getOffersForOfferCategory() {
    return this.offers$.pipe(
      switchMap((offers) => (offers.length == 0 ? this.offerService.getOffers() : of(offers))),
      filter((offers) => offers.length > 0),
      map((offers) =>
        offers.find((offer) => offer.offerCategoryId == this.getValue()?.currCatId),
      ),
    );
  }

  private getCurrOffer() {
    return this.offers$.pipe(
      filter((offers) => offers.length > 0),
      map((offers) =>
        offers.find((offer) => offer.offerCategoryId == this.getValue()?.currCatId),
      ),
      map((offers) => {
        const offerId = this.getValue()?.currOfferId;
        return offers?.data?.find((b) => b.id == offerId);
      }),
    );
  }
}
